import './ClassicEventView.scss';
import '../EventDetails/EventDetails.scss';
import { Divider } from "@mui/material";
import ClassicReleaseEventDetail from './ClassicReleaseEventDetail';
import ClassicSpecialEventView from './ClassicSpecialEventView';
import CommonPairingView from '../CommonPairingView/CommonPairingView';
import EventDetailsHeader from '../EventDetails/EventDetailsHeader';
import { eventActivityType } from '../../constants/myBlockMonth';
import { pairingById } from '../../models/PairingByIdInterface';
import { getEventName, getEventSubTitle } from '../../pages/MyBlockMonth/myBlockMonthHelper';

function ClassicEventView({
  actualView, 
  events,
  handleViewAllClick,
  numberOfEvents, 
  selectedEventIndex, 
  setSelectedEventIndex,
  viewAll,
  noData
  }) {
  const formatClassicEventPairingListData = (pairingList) => {
    let tempArray = [{} as any]
    let tempSeg = [] as any;
    let hotelSeg = [] as any;
    pairingList.forEach((e, i) => {
      if (e.activityType === 'Pairing') {
        e.pairingDetails.events.forEach(event => {
          event.segments.forEach(segment => {
            segment.hotelSegment.forEach(hotel => {
              hotelSeg.push({
                daycount: hotel.daycount,
                legno: hotel.legno,
                flightSegment: hotel.flightSegment,
                hotel: hotel.hotel,
                mls: hotel.mls,
                allFlight: hotel.allFlight,
                allHotel: hotel.allHotel,
                checkInTime: hotel.checkInTime,
                checkOutTime: hotel.checkOutTime,
                dpgDayCredit: hotel.dpgDayCredit,
                dpgNightCredit: hotel.dpgNightCredit,
                totalLayover: hotel.totalLayover.value,
                hotelName: hotel.hotel?.name,
                hotelNumber:  hotel.hotel?.phone
              })
            })
            //end of hotelsegment
            tempSeg.push({
              daycount: segment.daycount,
              legno: segment.legno,
              departAirport: segment.departure.airportCode,
              arrivalAirport: segment.arrival.airportCode,
              layover: segment.layover.value,
              day: segment.day.value,
              night: segment.night.value,
              tDuty: segment.tDuty,
              fltNo: segment.fltNo,
              deadhead: segment.deadhead,
              carierCode: segment.carierCode,
              redeye: segment.redeye,
              departDate: segment.departure.date,
              departTime: segment.departure.time.value,
              departTimeDeviation: segment.departure.time.deviation,
              arrivalTime: segment.arrival.time.value,
              arrivalTimeDeviation: segment.arrival.time.deviation,
              flightSegment: segment.flightSegment,
              totalSegmentActual: segment.total,
              totalDutySegment: segment.tDuty,
              hotelSegment: hotelSeg,
            })
            hotelSeg = [];
          })
        })
        //end of segment
        let temp = {} as pairingById
        if (e) {
          temp.activityType = e.activityType
          temp.base = e?.pairingDetails.base || '';
          temp.pairingDates = e?.pairingDetails.pairingDates?.length > 0 ? e.pairingDetails.pairingDates[0] : [];
          temp.block = e?.pairingDetails.block;
          temp.tafb = e?.pairingDetails.tafb?.value;
          temp.totalAllowance = e?.pairingDetails.totalAllowance.value;
          temp.remarks = e?.pairingDetails.remarks;
          temp.osea = e?.pairingDetails.osea;
          temp.eff = e?.pairingDetails.eff;
          temp.credit = e?.pairingDetails.credit.value;
          temp.pairingId = e?.pairingDetails.pairingId;
          temp.pairingType = e?.pairingType;
          temp.redeyecredit = e?.pairingDetails.redeyecredit;
          temp.adg_credit = e?.pairingDetails.adg_credit;
          temp.position = e?.pairingDetails.position;
          temp.frmsPairingDesignator = e?.pairingDetails.frmsPairingDesignator || '';
          temp.equipment = e?.pairingDetails.equipment || '';
          temp.onduty = e?.checkIn.value;
          temp.offduty = e?.checkOut.value;
          temp.frequency = e?.pairingDetails.frequency || '';
          temp.ttgOverSeasDayCredit = e?.pairingDetails.ttgOverSeasDayCredit;
          temp.ttgOverSeasNgtCredit = e?.pairingDetails.ttgDomesticNgtCredit;
          temp.ttgDomesticDayCredit = e?.pairingDetails.ttgDomesticDayCredit;
          temp.ttgDomesticNgtCredit = e?.pairingDetails.ttgDomesticNgtCredit;
          temp.checkInDeviation = e?.checkIn.deviation;
          temp.checkOutDeviation = e?.checkOut.deviation;
          temp.creditDeviation = e?.pairingDetails.credit?.deviation;
          temp.segments = tempSeg;
          temp.unique_id = e?.unique_id;
          tempSeg = [];
        }
        tempArray.push(temp);
      }
      else{
        tempArray.push(e);
      }
    })
    tempArray.shift()
    return [...tempArray];
  }

  return (
    <div className='c-event-details-view'>
      <EventDetailsHeader
        handleViewAllClick={handleViewAllClick}
        numberOfEvents={numberOfEvents}
        selectedEventIndex={selectedEventIndex}
        setSelectedEventIndex={setSelectedEventIndex}
        viewAll={viewAll}
        noData={noData}
      />
      <>
        {!noData ? (
          <div className="classicEventView_container">
            {events[0]?.release && events[0].activityType === eventActivityType.PAIRING 
              ? <ClassicReleaseEventDetail activityType={events[0].activityType} event={events[0]?.release[0]} /> 
              : null
            }
            {formatClassicEventPairingListData(events).map(event =>
              <>
                <div className="classic-header-main" id={`event-details__${event.unique_id}`}>
                  <span className="classic-title">
                    {event.activityType === eventActivityType.PAIRING 
                      ? event.pairingId
                      : (`${getEventSubTitle(event)} (${getEventName(event)})`)
                    }
                  </span>
                </div>
                {events[0]?.release && events[0].activityType === eventActivityType.PAIRING ? null : <Divider />}
                <div className="classic-body">
                  {event.activityType === eventActivityType.PAIRING 
                    ? <CommonPairingView details={event} myBlockMonth={true} actualView={actualView} />
                    : <ClassicSpecialEventView activityType={event.activityType} event={event} />
                  }
                  {viewAll ? <div><br /><hr /><br /> </div> : null}
                </div>
              </>
            )}
          </div>
        ) : <div className="no-data-content"></div>}
      </>
    </div>
  );
}

export default ClassicEventView;
